import React from 'react';
import _map from 'lodash/map';

import Container from '@atoms/Container';
import useCalculatorState from 'hooks/useCalculatorState';
import StepButton from '@atoms/StepButton';
import { CalculatorStateStep } from 'interfaces/calculator';
import { CalculatorStepState } from 'enums/calculator';

import styles from './styles';

const StepsBar = () => {
  const {
    steps,
    jumpToStep,
  } = useCalculatorState();

  const onStepClick = (step: CalculatorStateStep, index: number) => {
    if (step.state === CalculatorStepState.COMPLETED) {
      jumpToStep(index);
    }
  };

  return (
    <Container background className={styles.component}>
      {
        _map(steps, (step: CalculatorStateStep, index) => {
          const isLast = index === steps.length - 1;
          const { state, title } = step;
          return (
            <article key={title} className={styles.buttonContainer(isLast)}>
              <StepButton
                state={state}
                arrow={!isLast}
                onClick={() => onStepClick(step, index)}
                disabled={step.state !== CalculatorStepState.COMPLETED}
              >
                {title}
              </StepButton>
            </article>
          );
        })
      }
    </Container>
  );
};

export default StepsBar;
